// import PageLayout from 'pages/LTI/Incomplete/PageLayout';

// const LTIIncomplete = () => {
//     return (
//         <PageLayout
//             title='LTI Incomplete'
//             onSubmit={null}
//             link='/login'
//             linkMsg='Return to Sign In'
//             errorMsg='Error, this error is not handled for the beta'
//             jump='/'
//         />
//     );
// };

// export default LTIIncomplete;

export default () => null;
